import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import PortalHome from './components/PortalHome';
import SoccerApp from './components/SoccerApp';
import RunningApp from './components/RunningApp';
import HikingApp from './components/HikingApp';
import LegacySoccerRedirect from './components/LegacySoccerRedirect';
import DuplicateSoccerRedirect from './components/DuplicateSoccerRedirect';
import BlogApp from './components/BlogApp';
import TrainingApp from './components/TrainingApp';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import AccountProfile from './components/AccountProfile';
import GaPageViews from './components/GaPageViews';
import { SpeedInsights } from '@vercel/speed-insights/react';

function App() {
  return (
    <AuthProvider>
      <Router>
        <GaPageViews />
        <SpeedInsights />
        <div className="App">
          <Routes>
            <Route path="/" element={<PortalHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/register" element={<Signup />} />
            <Route path="/account" element={<AccountProfile />} />
            <Route path="/training/*" element={<TrainingApp />} />
            <Route path="/blog/*" element={<BlogApp />} />
            <Route path="/running/*" element={<RunningApp />} />
            <Route path="/hiking/*" element={<HikingApp />} />
            <Route path="/soccer/soccer/*" element={<DuplicateSoccerRedirect />} />
            <Route path="/soccer/*" element={<SoccerApp />} />
            {/* Legacy URLs (bookmarks / shared links before /soccer prefix) */}
            <Route path="/reset-password" element={<LegacySoccerRedirect />} />
            <Route path="/players/*" element={<LegacySoccerRedirect />} />
            <Route path="/teams/*" element={<LegacySoccerRedirect />} />
            <Route path="/admin" element={<LegacySoccerRedirect />} />
            <Route path="/admin/*" element={<LegacySoccerRedirect />} />
            <Route path="/clubs/*" element={<LegacySoccerRedirect />} />
            <Route path="/matches/*" element={<LegacySoccerRedirect />} />
            <Route path="/practices/*" element={<LegacySoccerRedirect />} />
            <Route path="/register-player/*" element={<LegacySoccerRedirect />} />
            <Route path="/public/*" element={<LegacySoccerRedirect />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
